import React from 'react'
import arrow from '../images/Vector (12) (1).png';

const ExploreArrow = () => {
  return (
    <div className='blackBack'>
        <img src={arrow} alt="arrow" className='arrow-image'/>
    </div>
  )
}

export default ExploreArrow